import React from 'react'
import {
    Button,
    makeStyles,
} from '@material-ui/core'
import { clsx } from 'clsx';

const linearGradient = "linear-gradient(90deg, #87959C 1.44%, #89959C 7.69%, #8B949B 13.94%, #B1B3BB 21.15%, #C3C8CC 31.25%, #F1F2F4 38.94%, #D2DBE6 51.44%, #D2DBE6 63.46%, #9AB0B7 81.73%, #A5B7C0 94.71%)"
const linearGradientHover = "linear-gradient(90deg, #606067, #A3A4A9, #D5D8E0, #767A7D )"
const linearGradientBackground = "linear-gradient(90deg, #87959C, #89959B, #8B949B, #B1B3BB, #C3C8CC, #F1F2F4 40%, #D2DBE6, #D2DBE6, #9AB0B7, #A5B7C0 )"

const useStyles = makeStyles(() => ({
    outlinedButton: {
        position: "relative",
        background: "transparent",
        color: '#ffffff',
        textTransform: 'none',
        fontSize: '16px',
        lineHeight: 1,
        padding: "16px 32px",
        borderRadius: "6px",
        border: "none",
        transition: "all 0.3s ease",
        "& .MuiButton-label": {
            color: '#ffffff',
            position: 'relative',
            zIndex: 2,
        },
        "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: "6px",
            padding: "1px",
            background: linearGradient,
            WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
            WebkitMaskComposite: "destination-out",
            maskComposite: "exclude",
            pointerEvents: "none",
            zIndex: 1,
        },
        "&:hover": {
            background: "rgba(255, 255, 255, 0.08)",
        }
    },
    containedButton: {
        background: linearGradientBackground,
        backgroundPosition: "left",
        backgroundSize: "100% 100%",
        fontFamily: '"Roboto", sans-serif',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '100%',
        letterSpacing: '0%',
        textTransform: 'capitalize',
        padding: "16px 32px",
        borderRadius: "6px",
        transition: "all 0.3s ease",
        "& .MuiButton-label": {
            color: '#111111',
            fontFamily: '"Roboto", sans-serif',
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '100%',
            letterSpacing: '0%',
            textTransform: 'capitalize',
        },
        "&:hover": {
            backgroundSize: "110% 100%",
        },
        '@media (max-width: 600px)': {
            width: '348px',
            maxWidth: '100%',
            height: '38px',
            padding: '16px 32px',
            borderRadius: '6px',
            gap: '10px',
            opacity: 1,
        }
    },
    containedPinkButton: {
        background: "linear-gradient(90deg, #CF819D, #FFB8D1, #CF819D)",
        backgroundPosition: "left",
        backgroundSize: "100% 100%",
        textTransform: 'none',
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: 1,
        padding: "16px 32px",
        borderRadius: 0,
        transition: "all 0.3s ease",
        "& .MuiButton-label": {
            color: '#111111',
        },
        "&:hover": {
            backgroundSize: "110% 100%",
        }
    }
}))

export const OutlinedButton = ({ text, styles, onClick }: { text: string, styles?: string, onClick?: React.MouseEventHandler<HTMLButtonElement> }) => {
    const classes = useStyles()
    return (
        <Button variant="outlined" className={clsx(classes.outlinedButton, styles)} onClick={onClick}>
            {text}
        </Button>
    )
}
export const ContainedButton = ({ text, styles, onClick }: { text: string, styles?: string, onClick?: React.MouseEventHandler<HTMLButtonElement> }) => {
    const classes = useStyles()
    return (
        <Button variant="contained" className={clsx(classes.containedButton, styles)} onClick={onClick}>
            {text}
        </Button>
    )
}
export const ContainedPinkButton = ({ text, styles, onClick }: { text: string, styles?: string, onClick?: React.MouseEventHandler<HTMLButtonElement> }) => {
    const classes = useStyles()
    return (
        <Button variant="contained" className={clsx(classes.containedPinkButton, styles)} onClick={onClick}>
            {text}
        </Button>
    )
}